import { LegalPage } from './LegalPage';

const sections = [
  {
    title: 'Your agreement with Lighthouse',
    body: [
      'By creating an account or using Lighthouse Jobs you are entering into a binding agreement with Lighthouse Staffing Solutions Ltd. These terms govern your access to the web apps, APIs, and supporting services.',
    ],
    bullets: [
      'You must provide accurate information and keep your credentials secure.',
      'You will only use Lighthouse Jobs for lawful purposes and will not attempt to scrape, disrupt, or reverse engineer the service.',
      'Admins may suspend or terminate access where policy or legal breaches occur.',
    ],
  },
  {
    title: 'Candidate responsibilities',
    body: [
      'Candidates control the information that is shared with employers. You grant Lighthouse the right to host, process, and transmit that information for the purpose of job discovery, matching, and communication.',
    ],
    bullets: [
      'You must only upload documents you have the right to share.',
      'Feedback loops (matches, skills, interview prep) are advisory and do not guarantee employment.',
    ],
  },
  {
    title: 'Employer responsibilities',
    body: [
      'Employers agree to use Lighthouse to interact with candidates in good faith, respect privacy choices, and comply with anti-discrimination laws.',
    ],
    bullets: [
      'No direct marketing or outreach outside the Lighthouse platform unless a candidate has opted in.',
      'Employers must keep interview feedback confidential and may not share candidate data with third parties without consent.',
    ],
  },
  {
    title: 'Liability, uptime, and service changes',
    body: [
      'The service is provided on an "as is" basis. While we aim for high availability, outages or maintenance windows may occur. Lighthouse is not liable for indirect or consequential damages, lost revenue, or employment outcomes.',
      'We may update these terms, features, or pricing from time to time. Material changes will be communicated inside the product or by email.',
    ],
  },
  {
    title: 'Contact and disputes',
    body: [
      'If you have a concern regarding these terms, contact the team. Any disputes will be governed by the laws of England and Wales.',
    ],
  },
];

export function TermsPage() {
  return (
    <LegalPage
      title="Terms of Service"
      description="Rules of engagement for candidates, employers, and administrators using the Lighthouse platform."
      lastUpdated="14 November 2025"
      path="/terms"
      sections={sections}
    />
  );
}
